// extracted by mini-css-extract-plugin
export default {"leftCol":"PartnersLeadListView_leftCol__GScfq"};